var render, staticRenderFns
import script from "./renderHeaderSlot.vue?vue&type=script&lang=js"
export * from "./renderHeaderSlot.vue?vue&type=script&lang=js"
import style0 from "./renderHeaderSlot.vue?vue&type=style&index=0&id=9c39dca6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c39dca6",
  null
  
)

export default component.exports